import { render, staticRenderFns } from "./mobile-section-header.vue?vue&type=template&id=5030d7c7&scoped=true&"
import script from "./mobile-section-header.vue?vue&type=script&lang=js&"
export * from "./mobile-section-header.vue?vue&type=script&lang=js&"
import style0 from "./mobile-section-header.vue?vue&type=style&index=0&id=5030d7c7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030d7c7",
  null
  
)

export default component.exports